<div class="containerSendPasswordResetLink">
  <a [class.disabled]="disabled" (click)="onClickLink()">{{ label }}</a>
</div>

<div class="modal" *ngIf="showSendMailConfirmModal">
  <div class="modalOverlay" (click)="onCancelSendResetMail()"></div>
  <div class="modalContainer">
    <div class="modalContent">
      <h5 class="modalContentTitle">
        パスワード再設定
      </h5>
      <p>{{ email }} にパスワード再設定メールを送信します。</p>
    </div>
    <div class="modalControl">
      <a (click)="onCancelSendResetMail()">キャンセル</a>
      <a (click)="onConfirmSendResetMail()">OK</a>
    </div>
  </div>
</div>

<div class="modal" *ngIf="showSendMailFinishedModal">
  <div class="modalOverlay" (click)="onCancelSendResetMail()"></div>
  <div class="modalContainer">
    <div class="modalContent">
      <h5 class="modalContentTitle">
        確認
      </h5>
      <p>
        メールが届かない場合は、メールアドレスをご確認の上、再度パスワード再設定メールを送信してください。
      </p>
    </div>
    <div class="modalControl">
      <a (click)="onClickConfirmModal()">OK</a>
    </div>
  </div>
</div>

<app-loading-modal [show]="loading"></app-loading-modal>
